<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter class="tablet" paso="1" />
      <wrap-container class="grid-container grid-container--6-6">
        <wrap-container class="col1">
          <form-validator>
            <wrap-container>
              <p id="titulo" class="titulo p28 oscuro">
                ¡Hola <span data-obfuscate>{{ model.nombre }}</span
                >!
              </p>
              <p
                id="titulo"
                class="titulo p32 medium oscuro"
                v-safe-html="config.pasos.confirmar.titulo"
              />
              <div class="subtitulo">
                <p
                  id="subtitulo"
                  class="titulo oscuro"
                  v-safe-html="config.pasos.confirmar.subtitulo"
                />
              </div>
            </wrap-container>
            <wrap-container class="celular">
              <section-label value="Celular" />
              <wrap-container>
                <phone-number
                  v-model="model.celular"
                  :required="true"
                  quantumObfuscate
                />
              </wrap-container>
            </wrap-container>
            <wrap-container>
              <email-field
                class="email"
                name="email"
                v-model="model.email"
                :required="true"
                quantumObfuscate
              />
            </wrap-container>
            <step-navigator
              v-model="model"
              :store-action="this.doNext"
              analyticsName="confirmar"
            />
          </form-validator>
        </wrap-container>
        <wrap-container class="col2 image-container">
          <img class="image" src="@/assets/img/1x/chat.svg" alt="Chatear" />
        </wrap-container>
      </wrap-container>
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import PhoneNumber from "@/components/core/composite/PhoneNumber";
import StepCounter from "@/components/core/StepCounter";
import SectionLabel from "@/components/core/SectionLabel";
import StepNavigator from "@/components/core/StepNavigator";
import { DO_CONFIRMAR_DATA_NOCLIENTE } from "../config/constants/action-types";
import EmailField from "@/components/core/EmailField";

export default {
  name: "Paso4",
  components: {
    WrapContainer,
    FormValidator,
    PhoneNumber,
    StepCounter,
    SectionLabel,
    StepNavigator,
    EmailField
  },
  data() {
    return {
      model: this.$store.getters.getConsulta(),
      doNext: DO_CONFIRMAR_DATA_NOCLIENTE
    };
  },
  beforeMount() {
    // Modificamos la cantidad de pasos
    this.config.cantPasos = 2;
  },
  mounted() {
    /* Si no hay oferta... Vuelvo a la consulta */
    if (PRODUCTION && !this.$store.state.dataOferta.oferta.valid) {
      this.$router.push("/");
    }

    this.$store.watch(
      this.$store.getters.getConsulta,
      model => {
        this.model = model;
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
.cobranding-logo-header {
  top: 36px;
}
.subtitulo {
  font-size: 15px;
  line-height: 1.3em;
}

#titulo {
  margin-bottom: 15px;
}

#subtitulo {
  margin-bottom: 45px;
}

.email {
  margin-top: 16px;
  padding-bottom: 20px;
}

.image {
  display: block;
  margin-bottom: 8px;
  margin-top: 40px;
  margin-left: auto;
  margin-right: auto;
}

@media screen and (max-width: 900px) {
  .image {
    width: 250px;
  }
}

@media screen and (max-width: 599px) {
  .image {
    display: none;
  }
  .image-container {
    background-color: #cae8fc;
  }
}

@media screen and (max-width: 600px) {
  .email {
    width: 100%;
  }
  .celular {
    margin-top: 40px;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .w50 {
    width: 80%;
    max-width: 1024px;
    margin-left: 10%;
    margin-right: 10%;
  }

  .cascade {
    display: block;
  }

  .tablet {
    margin-left: 10%;
  }
}
</style>
